import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const Dairy: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 12 20" {...props}>
      <path
        d="M9.3279 2.60195C10.0164 2.56621 10.5651 2.00168 10.5651 1.30434C10.5651 0.583945 9.9811 0 9.26071 0H2.73899C2.0186 0 1.43462 0.583945 1.43462 1.30434C1.43462 2.00168 1.98329 2.56621 2.67181 2.60191C2.26462 6.28438 0.782471 6.52695 0.782471 10.231V18.0435C0.782471 19.1223 1.66013 20 2.73899 20H9.26075C10.3396 20 11.2173 19.1223 11.2173 18.0435V10.231C11.2172 6.52074 9.73606 6.29355 9.3279 2.60195ZM5.57399 8.06277C4.6706 7.46047 3.59923 7.23328 2.58224 7.35906C2.70036 7.02414 2.83759 6.69609 2.9963 6.37863C3.52685 5.31687 3.85681 3.8718 3.98349 2.60867H8.01626C8.1429 3.8718 8.47286 5.31687 9.00345 6.37863C9.2245 6.8207 9.40646 7.2825 9.54833 7.75637C9.07028 7.99359 7.50005 9.34684 5.57399 8.06277Z"
        fill={colors.grey}
      />
    </SvgIcon>
  );
};

export default Dairy;
